import { FC } from 'react';
import { RiArrowRightWideFill } from 'react-icons/ri';
import { FeatureFlag } from './FeatureFlagConfig.utils';
import { Control, Controller } from 'react-hook-form@latest';
import { _notNil } from '@/littledash';
import Switch from '@/components/UI/FormElements/Switch';
import styles from './FeatureFlagConfig.module.scss';

const TD_CLASSES = 'f7 f6-l ph2 pv2 ph3-l pv2-l mw1';

interface FlagRowProps {
  flag: FeatureFlag;
  control: Control;
  expandState?: { expanded: boolean; onToggle: () => void };
  nested?: boolean;
  disabled?: boolean;
}

const FlagRow: FC<FlagRowProps> = ({ flag, control, expandState, nested, disabled }) => {
  const chevronClass = [styles.expandChevron, expandState?.expanded && styles.expandChevronOpen]
    .filter(Boolean)
    .join(' ');

  return (
    <Controller
      name={flag.name}
      control={control}
      defaultValue={flag.value}
      render={({ field: { onChange, value } }) => {
        const isDirty = value !== flag.value;
        const rowClass = [isDirty && styles.dirtyRow, disabled && styles.disabledRow].filter(Boolean).join(' ');
        return (
          <tr
            className={rowClass}
            data-test-component="FlagRow"
            data-test-element="container"
            data-test-key={flag.name}
          >
            <td className={`${TD_CLASSES} br`}>
              <div className="flex items-center" style={{ paddingLeft: nested ? '1.5rem' : undefined }}>
                {nested && (
                  <span className={styles.treeIndicator} aria-hidden="true">
                    └
                  </span>
                )}
                {_notNil(expandState) && (
                  <span
                    className="pointer mr1 flex items-center justify-center"
                    role="button"
                    tabIndex={0}
                    aria-expanded={expandState.expanded}
                    aria-label={expandState.expanded ? 'Collapse children' : 'Expand children'}
                    onClick={expandState.onToggle}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        expandState.onToggle();
                      }
                    }}
                    style={{ width: '18px', height: '18px' }}
                  >
                    <RiArrowRightWideFill size={14} className={chevronClass} />
                  </span>
                )}
                {flag.display_name}
              </div>
            </td>
            <td className={`${TD_CLASSES} br`}>{flag.description}</td>
            <td className={TD_CLASSES}>
              <div className="flex items-center" style={{ minHeight: '28px' }}>
                <Switch value={value} onChange={onChange} disabled={disabled} testId="switch" />
                <p className="ml3">{value ? 'True' : 'False'}</p>
              </div>
            </td>
          </tr>
        );
      }}
    />
  );
};

export default FlagRow;
